export const RELATED_CONTENT_DEFAULT_PER_PAGE = 6
